<template>
  <div>
    <div class="page-header clear-filter" filter-color="">
      <parallax
        class="page-header-image"
        style="background-image:url('img/comp1.png')"
      >
      </parallax>
      <div class="container">
        <h2 class="title mt-5">{{ $t('certification.hero.title') }}</h2>
      </div>
    </div>
    <div class="section section-tabs">
      <div class="container">

        <div class="cert-section">
          <div class="cert-header">
            <img
            src="img/icon/icon (21).png" alt=""
            width="6%"
            class="mr-3"
          /> {{ $t('certification.certSection.heading') }}
          </div>

          <h5>{{ $t('certification.certSection.intro') }}</h5>

          <div class="cert-grid">
            <div class="cert-card" @click="form.show = 'true'" style="cursor: pointer;">
              <img src="img/iso_new.png" alt="ISO">
              <span>ISO 9001:2015</span>
            </div>
            <div class="cert-card" @click="formAsme.show = 'true'" style="cursor: pointer;">
              <img src="img/asme.png" alt="ASME">
              <span>ASME U and R Stamp</span>
            </div>
            <div class="cert-card" @click="formNb.show = 'true'" style="cursor: pointer;">
              <img src="img/nbbi.png" alt="NB">
              <span>The National Board Certificate U</span>
            </div>
            <div class="cert-card" @click="formNbR.show = 'true'" style="cursor: pointer;">
              <img src="img/nbbi.png" alt="NB">
              <span>The National Board Certificate R</span>
            </div>
            <div class="cert-card" @click="formMigas.show = 'true'" style="cursor: pointer;">
              <img src="img/icon/migas.png" width="22%" alt="MIGAS">
              <span>MIGAS Certificate</span>
            </div>
            <div class="cert-card" @click="formEbtke.show = 'true'" style="cursor: pointer;">
              <img src="img/etbk.png" alt="EBTKE"> 
              <span>EBTKE Certificate</span>
            </div>
            <!-- <div class="cert-card" @click="formKemnaker.show = 'true'" style="cursor: pointer;">
              <img src="img/kemnaker.png" alt="Kemnaker">
              <span>KEMNAKER Certificate</span>
            </div> -->
          </div>

          <h5>{{ $t('certification.certSection.otherCodesIntro') }}</h5>

          <div class="code-buttons">
            <div class="btn"><i class="fas fa-certificate"></i> {{ $t('certification.certSection.otherCodes.japanese') }}</div>
            <div class="btn"><i class="fas fa-certificate"></i> DOSH (Malaysia)</div>
            <div class="btn"><i class="fas fa-certificate"></i> MOM (Singapore)</div>
          </div>
        </div>

        <!-- <div class="row justify-content-center">
          <div class="col-8">
            <el-carousel height="990px">
              <el-carousel-item>
                <img class="d-block" src="img/certification/asme_u.jpg" alt="First slide" />
                <div class="carousel-caption d-none d-md-block">
                  <h5 style="color: black;" class="font-weight-bold">ASME U Certificate</h5>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/certification/iso.jpg" alt="Second slide" />
                <div class="carousel-caption d-none d-md-block">
                  <h5 style="color: black;" class="font-weight-bold">ISO 9001 Certificate</h5>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/certification/nb_auth.jpg" alt="Second slide" />
                <div class="carousel-caption d-none d-md-block">
                  <h5 style="color: black;" class="font-weight-bold">NB Certificate of Authorization</h5>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/certification/nb_r.jpg" alt="Third slide" />
                <div class="carousel-caption d-none d-md-block">
                  <h5 style="color: black;" class="font-weight-bold">NB R Certificate of Authorization</h5>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div> -->

    </div>
  </div>

    <!-- MOTO TOKKI  -->
    <div class="page-header clear-filter moto-office-section" filter-color="purple">
      <div class="parallax">
        <div class="container" style="">
          <h1 class="text-white text-left pt-5 font-weight-bold text-center">START <span style="font-size: 20px; color: yellow;"> {{ $t('common.offices.motoStartWithTokki') }} </span></h1>
          <div class="row pt-5 mt-n4">
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.mainOfficeFactory') }}  :</span></h6>
              Kawasan Industri Jababeka 1
              Jl.Jababeka XIIB Blok W26
              Cikarang-Bekasi, Jawa Barat Indonesia Kode Pos 17530
              Telp: +62-21 893 6733 (Hunting) <br><br>

              Phone : +62 - 21 8936733 (Hunting)<br>
              Fax   : +62 - 21 8936738<br>
              Email : sales@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.secondOfficeFactory') }}</span></h6>
              Kawasan Industri Krakatau 1,
              Jl. Australia I Kav. C1/2, Kel. Warnasari, Kec. Citangkil
              Kota Cilegon, Banten - Indonesia 42443 <br><br>

              Phone : +62 - 254 8317244<br>
              Fax   : +62 - 254 8317244<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.thirdOfficeFactory') }}</span></h6>
              Pergudangan AKR GEM City F-09, Kabupaten Gresik, Jawa Timur <br><br><br>

              Phone : +62 - 31 39935914<br>
              Fax   : +62 - 31 39935914<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left mb-5">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.fourthMarketingOffice') }}</span></h6>
              Jl. Gn. Leuser, Tj. Marulak, Kec. Rambutan, Kota Tebing Tinggi, Sumatera Utara 20998 <br><br><br>

              Phone : +62 811-1972-2507<br>
              Email : sales@tef.co.id<br>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- CERT ISO -->
    <modal :show.sync="form.show" headerClasses="justify-content-center" >
      <h6 slot="header" class="title title-up" style="margin-top: 0px;"></h6><hr style="margin-top: -15px;" class="mb-4">
      <p class="mb-5">
         <img src="img/certification/iso.jpg" alt="Kemnaker">
      </p>
      <template slot="footer">
      </template>
    </modal>
    <!-- CERT ASME U & R -->
    <modal :show.sync="formAsme.show" headerClasses="justify-content-center" >
      <h6 slot="header" class="title title-up" style="margin-top: 0px;"></h6><hr style="margin-top: -15px;" class="mb-4">
      <p class="mb-5">
         <img src="img/certification/asme.jpg" alt="ASME">
      </p>
      <template slot="footer">
      </template>
    </modal>
    <!-- CERT NB -->
    <modal :show.sync="formNb.show" headerClasses="justify-content-center" >
      <h6 slot="header" class="title title-up" style="margin-top: 0px;"></h6><hr style="margin-top: -15px;" class="mb-4">
      <p class="mb-5">
         <img src="img/certification/nb_auth.jpg" alt="Kemnaker">
      </p>
      <template slot="footer">
      </template>
    </modal>
    <!-- CERT MIGAS -->
    <modal :show.sync="formMigas.show" headerClasses="justify-content-center" >
      <h6 slot="header" class="title title-up" style="margin-top: 0px;"></h6><hr style="margin-top: -15px;" class="mb-4">
      <p class="mb-5">
         <img src="img/certification/migas.jpg" alt="Kemnaker">
      </p>
      <template slot="footer">
      </template>
    </modal>
    <!-- CERT EBTKE -->
    <modal :show.sync="formEbtke.show" headerClasses="justify-content-center" >
      <h6 slot="header" class="title title-up" style="margin-top: 0px;"></h6><hr style="margin-top: -15px;" class="mb-4">
      <p class="mb-5">
         <img src="img/certification/ebtkbe.jpg" alt="Kemnaker">
      </p>
      <template slot="footer">
      </template>
    </modal>
    <!-- CERT KEMNAKER -->
    <modal :show.sync="formNbR.show" headerClasses="justify-content-center" >
      <h6 slot="header" class="title title-up" style="margin-top: 0px;"></h6><hr style="margin-top: -15px;" class="mb-4">
      <p class="mb-5">
         <img src="img/certification/nb_r.jpg" alt="Kemnaker">
      </p>
      <template slot="footer">
      </template>
    </modal>

  </div>
</template>
<script>
import { Carousel, CarouselItem } from 'element-ui';
import { Modal } from '@/components';

export default {
  name: 'profile',
  bodyClass: 'profile-page',
  components: {
    Modal,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  methods: {
    // toDetailProduct(param){
    //   this.$router.push('/detail-product/'+param)
    // }
  },
  data () {
    return {
      form: {
        add: true,
        title: "",
        show: false
      },
      formAsme: {
        add: true,
        title: "",
        show: false
      },
      formNb: {
        add: true,
        title: "",
        show: false
      },
      formMigas: {
        add: true,
        title: "",
        show: false
      },
      formEbtke: {
        add: true,
        title: "",
        show: false
      },
      formNbR: {
        add: true,
        title: "",
        show: false
      },

    }
  },

};
</script>
<style>
   .animated {
     
      padding-top:0px;
      margin-bottom:0px;
      -webkit-animation-duration: 5s;
      animation-duration: 5s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
   }
   
   @-webkit-keyframes fadeInDown {
      0% {
         opacity: 0;
         -webkit-transform: translateY(-20px);
      }
      100% {
         opacity: 1;
         -webkit-transform: translateY(0);
      }
   }
   
   @keyframes fadeInDown {
      0% {
         opacity: 0;
         transform: translateY(-50px);
      }
      100% {
         opacity: 1;
         transform: translateY(0);
      }
   }
   
   .fadeInDown {
      -webkit-animation-name: fadeInDown;
      animation-name: fadeInDown;
   }


  .cards:hover{
    box-shadow: 5px 6px 6px 2px #e9ecef;
    transform: scale(1.1);
    cursor: pointer;;
  }
</style>
<style>
    body {
      font-family: Arial, sans-serif;
      background-color: #dcdcdc;
    }

    .cert-section {
      background: #ffffff;
      border-radius: 20px;
      padding: 30px;
      max-width: 1000px;
      margin: auto;
      box-shadow: 0 4px 10px rgba(0,0,0,0.1);
    }

    .cert-header {
      display: flex;
      align-items: center;
      color: #007a3d;
      font-size: 1.8rem;
      font-weight: bold;
      margin-bottom: 15px;
    }

    .cert-header i {
      font-size: 1.8rem;
      margin-right: 12px;
    }

    .cert-section p {
      margin-bottom: 20px;
    }

    .cert-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      margin-bottom: 30px;
    }

    .cert-card {
      background: #f9f9f9;
      border-radius: 20px;
      padding: 15px 20px;
      flex: 1 1 calc(30% - 20px);
      text-align: center;
      min-width: 180px;
      box-shadow: 0 2px 6px rgba(0,0,0,0.05);
    }

    .cert-card img {
      max-height: 60px;
      margin-bottom: 10px;
    }

    .cert-card span {
      display: block;
      font-weight: bold;
    }

    .code-buttons {
      display: flex;
      flex-wrap: wrap;
      gap: 15px;
      margin-top: 15px;
    }

    .code-buttons .btn {
      background-color: #007a3d;
      color: white;
      padding: 8px 20px;
      border-radius: 15px;
      font-weight: bold;
      display: flex;
      align-items: center;
      gap: 10px;
      border: none;
      cursor: default;
    }

    .btn i {
      font-size: 1rem;
    }
  
.moto-office-section {
  max-height: none;
  height: auto;
  overflow: visible;
  padding-bottom: 40px;
}

.moto-office-section .parallax {
  height: auto;
  padding-bottom: 40px;
}
</style>
